<template>
  <div class="mt-4">
    <ul>
      <li>
        Se sont exprimés :
        {{ event.votes.votesFor.length + event.votes.votesAgainst.length }} copropriétaires
        totalisant
        {{ calculateVotesTantiems(event.votes.votesFor.concat(event.votes.votesAgainst)) }}
        tantièmes
      </li>
    </ul>
    <ul>
      <li
        v-if="event.votes.votesFor.length > 0 && !isRestricted('for', event.votes.votesFor.length)"
      >
        Ont voté pour : {{ event.votes.votesFor.length }} copropriétaires totalisant
        {{ calculateVotesTantiems(event.votes.votesFor) }} tantièmes <br />
        {{ sortedVotesByName(event.votes.votesFor) }}
      </li>
      <li
        v-if="
          event.votes.votesAbstain.length > 0 &&
          !isRestricted('abstain', event.votes.votesAbstain.length)
        "
      >
        Se sont abstenu : {{ event.votes.votesAbstain.length }} copropriétaire totalisant
        {{ calculateVotesTantiems(event.votes.votesAbstain) }} tantièmes <br />
        {{ sortedVotesByName(event.votes.votesAbstain) }}
      </li>
      <li
        v-if="
          event.votes.votesAgainst.length > 0 &&
          !isRestricted('against', event.votes.votesAgainst.length)
        "
      >
        Ont voté contre : {{ event.votes.votesAgainst.length }} copropriétaire totalisant
        {{ calculateVotesTantiems(event.votes.votesAgainst) }} tantièmes <br />
        {{ sortedVotesByName(event.votes.votesAgainst) }}
      </li>
      <!-- NOTE: Hide this if majorChangeBuildingOwners.length > 0 (Prevent duplicate values) -->
      <li
        v-if="
          event.votes.votesNsp.length > 0 &&
          !isRestricted('nsp', event.votes.votesNsp.length) &&
          majorChangeBuildingOwners.length == 0
        "
      >
        Sont considérés défaillants : {{ event.votes.votesNsp.length }} copropriétaire totalisant
        {{ calculateVotesTantiems(event.votes.votesNsp) }} tantièmes <br />
        {{ sortedVotesByName(event.votes.votesNsp) }}
      </li>
      <li v-if="majorChangeBuildingOwners.length > 0">
        Copropriétaires assimilés défaillant en vertu de l'article 17-1 de la loi du 10 juillet
        1965, suite à l'amendement de la résolution :
        {{ majorChangeNrOfBuildingOwners }} copropriétaire totalisant
        {{ majorChangeTotalTantiemes }} tantièmes <br />
        <span> {{ majorChangeBuildingOwners }} </span>
      </li>
    </ul>
  </div>
</template>
<script>
import { pdfsGeneratePvTypes } from "@/constants/pdf.js";
import { meetingResolutionStatuses } from "@/constants/meeting-resolution.js";
export default {
  inject: ["generatePvOption"],
  props: ["event", "resolution", "eventsMajorChanges"],
  data() {
    return {
      majorChangeTotalTantiemes: null,
      majorChangeBuildingOwners: [],
      majorChangeNrOfBuildingOwners: 0,
      pdfsGeneratePvTypes,
      meetingResolutionStatuses,
    };
  },
  created() {
    if (this.eventsMajorChanges.length > 0) {
      this.getMajorChangeBuildingOwners();
    }
  },
  methods: {
    getMajorChangeBuildingOwners() {
      let result = [];
      let majorChangeEvent = this.$_.find(this.eventsMajorChanges, mjEvent => {
        return mjEvent.resolution_id == this.event.resolution_id;
      });
      if (!majorChangeEvent) return;

      this.majorChangeTotalTantiemes = this.calculateVotesTantiems(majorChangeEvent.votes);
      majorChangeEvent.votes.forEach(vote => {
        let buildingOwner = this.getPersonName({ personId: vote.building_owner_id });
        let tantiemes = vote.tantiemes;
        result.push(`${buildingOwner} (${tantiemes})`);
        this.majorChangeNrOfBuildingOwners += 1;
      });
      this.majorChangeBuildingOwners = result.sort().join(", ");
    },
    calculateVotesTantiems(votes) {
      let tantiemes = 0;
      votes.forEach(vote => {
        tantiemes += vote.tantiemes;
      });
      return this.formatNumber(tantiemes);
    },
    sortedVotesByName(arrayOfVotes) {
      let result = [];
      arrayOfVotes.forEach(vote => {
        let buildingOwner = this.getPersonName({ personId: vote.building_owner_id });
        let tantiemes = vote.tantiemes;
        result.push(`${buildingOwner} (${tantiemes})`);
      });
      return result.sort().join(", ");
    },
    isRestricted(voteType, votesLength) {
      if (
        this.generatePvOption == this.pdfsGeneratePvTypes.generate_type_include_only_against_and_nsp
      ) {
        // NOTE: Case when is rejected due to lack of majority - keep the votes
        if (this.resolution.status == this.meetingResolutionStatuses.rejected_lack_of_majority) {
          return false;
          // NOTE: Case when Resolution is adopted - remove all votes with POUR
        } else if (
          voteType == "for" &&
          votesLength > 0 &&
          this.resolution.status == this.meetingResolutionStatuses.accepted
        ) {
          return true;
          // NOTE: Case when Resolution is rejected - remove all votes with CONTRE
        } else if (
          voteType == "against" &&
          votesLength > 0 &&
          this.resolution.status == this.meetingResolutionStatuses.rejected
        ) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
